import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchWorkFlowCategories(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('operation/work-flow-categories', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteWorkFlowCategory(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`operation/work-flow-categories/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
